import { send_to_server } from '@/services/socketio_client_react/send_to_server';
import { createAsyncThunkSafe } from '@/state/_base/createAsyncThunkSafe';
import { ActionReducerMapBuilder, PayloadAction } from '@reduxjs/toolkit';
import { RequestWorkspaceUserInvitationDelete } from '@shared/dto/+workspace/workspace_user_invitation/_requests/request_workspace_user_invitation_delete';
import { ENUM__network_event_client_to_server } from '@shared/network/ENUM__network_event_client_to_server';
import { STATE__workspace } from '../STATE__workspace';

export const remote_workspace_user_invitation_delete = createAsyncThunkSafe<void, RequestWorkspaceUserInvitationDelete[]>(
  ENUM__network_event_client_to_server.WORKSPACE_USER_INVITATION_DELETE,
  async (requests): Promise<void> => {
    await send_to_server(ENUM__network_event_client_to_server.WORKSPACE_USER_INVITATION_DELETE, requests);
  },
);

export function init_remote_workspace_user_invitation_delete(builder: ActionReducerMapBuilder<STATE__workspace>) {
  builder
    .addCase(remote_workspace_user_invitation_delete.pending, (state, action) => {})
    .addCase(remote_workspace_user_invitation_delete.rejected, (state, action) => {})
    .addCase(remote_workspace_user_invitation_delete.fulfilled, (state, action: PayloadAction) => {});
}
